module.exports = __webpack_public_path__ + "img/huan.49a70772.jpg";